import { render, staticRenderFns } from "./CustomerPopUp.vue?vue&type=template&id=97c90f34&scoped=true&"
import script from "./CustomerPopUp.vue?vue&type=script&lang=js&"
export * from "./CustomerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPopUp.vue?vue&type=style&index=0&id=97c90f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c90f34",
  null
  
)

export default component.exports